const CMP_ID = 999;
const CMP_VERSION = 2;

export interface Config {
  // WeTransfer's own CMP ID
  // Todo: Register as a private CMP
  cmpId: number;

  // WeTransfer's CMP version
  // This is an arbitrary number.
  cmpVersion: number;

  // Custom specific tc strings
  // https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20Consent%20string%20and%20vendor%20list%20formats%20v2.md#what-are-the-different-scopes-for-a-tc-string
  isSpecificService: boolean;

  vendorIds: Array<number>;

  consentIds: Array<number>;

  legitimateInterestIds: Array<number>;
}

export const VendorIds = {
  BEESWAX: 12,
  ADFORM: 50,
  SIZMEK: 68,
  OPENX: 69,
  FLASHTALKING: 78,
  DYNATA: 110,
  DOUBLE_VERIFY: 126,
  MEETRICS: 152,
  ADOBE_ADVERTISING: 264,
  INTEGRAL_AS: 278,
  WEBORAMA: 284,
  GEMIUS: 328,
  KANTAR_GROUP: 345,
  TREASURE_DATA: 9015,
  NIELSEN: 373,
  LUCID_HOLDINGS: 508,
  GOOGLE: 755,
  ORACLE_MOAT: 772,
  ADFARM: 9001,
  ADZERK: 9002,
  AMAZON: 9003,
  APPNEXUS: 9004,
  BING_MICROSOFT: 9005,
  DOUBLECLICK: 9006,
  FACEBOOK: 9007,
  MEDIAPLEX: 9008,
  RAPLEAF: 9009,
  SALESFORCE: 9010,
  SNOWPLOW: 9011,
  VISUAL_IQ: 9012,
  REDDIT: 9013,
  CRITEO: 9014,
  MIQ: 101,
  INNOVID: 452,
  CAPTIFY: 2,
  LINKEDIN: 804,
  BRANDMETRICS: 422,
};

// Note: IAB Purpose assigned id has a max number of 24
export const PurposeIds = {
  SELECT_BASIC_ADS: 2,
  MEASURE_AD_PERFORMANCE: 7,
  DEVELOP_IMPROVE_PRODUCTS: 10,
};

// WeTransfer's own purpose that is not registered with IAB
export const CustomPurposeIds = {
  // Note: IAB Purpose assigned id has a max number of 24
  PROMOTE_PRODUCTS: 20,
};

export function createConfig(): Config {
  // Non global tc string
  const isSpecificService = true;

  const vendorIds = Object.values(VendorIds);

  const consentIds = [
    PurposeIds.SELECT_BASIC_ADS,
    PurposeIds.MEASURE_AD_PERFORMANCE,
    CustomPurposeIds.PROMOTE_PRODUCTS,
  ];

  const legitimateInterestIds = Object.values(PurposeIds).concat([
    CustomPurposeIds.PROMOTE_PRODUCTS,
  ]);

  return {
    cmpId: CMP_ID,
    cmpVersion: CMP_VERSION,
    isSpecificService,
    vendorIds,
    consentIds,
    legitimateInterestIds,
  };
}

export default createConfig();
